import { GlobalStyles } from '@experiences/theme';
import { UiText } from '@experiences/ui-common';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { makeStyles } from '@mui/styles';
import createStyles from '@mui/styles/createStyles';
import React, { useMemo } from 'react';
import {
    FormattedMessage,
    useIntl,
} from 'react-intl';

import useEcommerceLearnMoreViewModel from './EcommerceLearnMoreViewModel';

const useStyles = makeStyles(theme => ({
    ...GlobalStyles(theme),
    ...createStyles({
        descriptionListItemText: {
            fontWeight: 400,
            fontSize: '14px',
            lineHeight: '20px',
            color: theme.palette.semantic.colorForeground,
        },
        listItemIcon: {
            margin: '8px 4px 0 0',
            minWidth: 'auto',
        },
        bullet: { fontSize: '6px' },
        includedServiceItem: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'left',
            alignItems: 'left',
            marginTop: '18px',
        },
        listContainer: {
            marginTop: '24px',
            overflow: 'hidden',
        },
        listItem: {
            padding: 0,
            alignItems: 'flex-start',
        },
    }),
}));
const ProductDescriptionList: React.FC<{
    productCode: string;
    planType: string;
}> = ({
    productCode, planType,
}) => {
    const classes = useStyles();
    const { formatMessage: translate } = useIntl();
    const {
        documentationLinksByProduct, getLearnMoreDescriptionTranslationId,
    } = useEcommerceLearnMoreViewModel();

    const translatedInfoList = useMemo(() => {
        const infoListTranslated: string[] = [];
        let iterator = 0;
        let foundTranslation = true;
        while (foundTranslation) {
            const translationKey = getLearnMoreDescriptionTranslationId(productCode, iterator, planType);
            const translatedString = translate({ id: translationKey });
            iterator = iterator + 1;
            if (translatedString !== translationKey) {
                infoListTranslated.push(translationKey);
            } else {
                foundTranslation = false;
            }
        }
        return infoListTranslated;
    }, [ productCode, translate ]);

    return (
        <div className={classes.listContainer}>
            <List
                dense
                disablePadding>
                {translatedInfoList.map((itemKey, index) =>
                    (<ListItem
                        key={index}
                        data-cy={`ecommerce-learn-more-description-${productCode}-${index}`}
                        disableGutters
                        className={classes.listItem}>
                        <ListItemIcon className={classes.listItemIcon}>
                            <FiberManualRecordIcon className={classes.bullet} />
                        </ListItemIcon>
                        <ListItemText>
                            <UiText className={classes.descriptionListItemText}>
                                <FormattedMessage
                                    id={itemKey}
                                    values={{
                                        a: (msg: React.ReactNode[]) =>
                                            (
                                                <a
                                                    className={classes.a}
                                                    href={documentationLinksByProduct[productCode]}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    {msg}
                                                </a>
                                            ),
                                    }}
                                />
                            </UiText>
                        </ListItemText>
                    </ListItem>))}
            </List>
        </div>
    );
};

export default ProductDescriptionList;
